module.exports = __webpack_public_path__ + "media/application/images/placeholder/medium@2x-bca93f488a475edc0024b6c5ba974ddd.jpg";